import { render } from "./FilterItemAdd.vue?vue&type=template&id=165bbeb0"
import script from "./FilterItemAdd.vue?vue&type=script&lang=js"
export * from "./FilterItemAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__